import type User from "entities/User.entity";

export type TelemetryIdentity =
  | { kind: "user"; user: User }
  | { kind: "kas"; id?: string; email?: string }
  | { kind: "none" };

// Priority telemetry identity: brev user, else KAS identity, else none.
// A null `me` must not clear an existing KAS identity.
export function resolveTelemetryIdentity(args: {
  me: User | null;
  starfleetId?: string;
  starfleetEmail?: string;
}): TelemetryIdentity {
  const { me, starfleetId, starfleetEmail } = args;
  if (me) return { kind: "user", user: me };
  if (starfleetId || starfleetEmail) {
    return { kind: "kas", id: starfleetId, email: starfleetEmail };
  }
  return { kind: "none" };
}
